<template>
  <dd-container>
    <dd-grid>
      <dd-grid-item :col-span-prop="2">
        <dd-header-card :wide-content="true" header="Klanten">
          <dd-main-table
              @update-selected="updateSelected"
              :headers="headers"
              :rows="customers"
              :paginator="paginator"
              @load-page="loadPage"
              :loading="loading"
          >

            <template v-slot:actions="{ row }">
              <div class="flex-row gap-xs">
                <dd-button :small="false">Bekijken</dd-button>
                <dd-button :small="true">Bekijken</dd-button>
                <dd-button :small="true" color="danger">
                  <template v-slot:icon>
                    <TrashIcon></TrashIcon>
                  </template>
                </dd-button>
              </div>
            </template>
          </dd-main-table>
        </dd-header-card>
      </dd-grid-item>
    </dd-grid>
  </dd-container>


</template>

<script>
import customerApi from '../../api/customer';
export default {
  name: "TablePage.vue",
  data() {
    return {
      selectedRows: [],
      loading: false,
      headers: [
        {
          title: 'Volledige naam',
          key: 'full_name'
        },
        {
          title: 'Birthday',
          key: 'birthday',
          width: 20
        }
      ],
      paginator: null,
      customers: [],
      requestHeader: {
        perPageOptions: [15, 30, 50],
        loading: true,
        reloadTimeout: null,
        currentPage: null,
        currentRequestData: null,
        page: 1,
        perPage: 15,
        orderBy: 'created_at',
        order: 'desc',
        filter: {},
      }
    }
  },
  methods: {
    loadPage(loadPageObject) {
      this.loading = true;
      customerApi.paginate(loadPageObject.page).then(x => {
        this.customers = x.data;
        this.paginator = x.meta.pagination;
        this.loading = false;
      })
    },
    updateSelected(selected) {
      this.selectedRows = selected;
    }
  },
  beforeMount() {
    this.loadPage({page: 1});
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
